import { Component, OnInit, Inject } from '@angular/core';
import copy from 'copy-to-clipboard';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels }
        from '@techiediaries/ngx-qrcode';
import {MatStepperModule} from '@angular/material/stepper';

@Component({
  selector: 'app-info-message',
  templateUrl: './info-message.component.html',
  styleUrls: ['./info-message.component.css']
})
export class InfoMessageComponent implements OnInit {

  // QRCODE: We can have Canvas/Img/Url as elementType
  elementType = NgxQrcodeElementTypes.URL;
  // QRCODE: We can have High/Low/Medium/Quartile
  correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
  // QRCODE: Need to specify the valid website address

  constructor(@Inject(MAT_DIALOG_DATA) public data, public dialogRef: MatDialogRef<InfoMessageComponent>) { }

  ngOnInit() {
  }

  getHeader() {
    if (this.data.type === 'Alert') {
      return 'Alert message';
    }
    if (this.data.type === 'Error') {
      return 'Error message';
    }
    if (this.data.type === 'translation') {
      return 'Translated to english';
    }
    if (this.data.type === 'mobile') {
      return 'How to start using Mobile version of portal';
    }
    return 'Information message';
  }

  noBillingError() {
    if (this.data.infoMessage === 'Billing Method not found') {
      return true;
    } else {
      return false;
    }
  }

  close() {
    this.dialogRef.close('setBilling');
  }

  copyAndClose() {
    copy(this.data.infoMessage.translation);
    this.dialogRef.close('copy');
  }

}
